import {
  LOAD_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_SUCCESS
} from '../actions/actionTypes';
import initialState from './initialState';
import deepExtend from 'deep-extend';

export default function customerReducer(
  customer = initialState.customer,
  action
) {
  switch (action.type) {
    case LOAD_CUSTOMER_SUCCESS:
      return action.customer;

    case UPDATE_CUSTOMER_SUCCESS:
      return deepExtend({}, action.customer);

    default:
      return customer;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/customerReducer.js